module.exports = {
    locale_name: 'Dutch',
    locale_shorthand: ['nl', 'dutch'],
    // Translations:
    justifyCenter: 'Gecentreerd uitlijnen',
    justifyLeft: 'Links uitlijnen',
    justifyRight: 'Rechts uitlijnen',
    bold: 'Vet',
    code: 'Code',
    headings: 'Titels (h1-h6)',
    link: 'Hyperlink',
    image: 'Afbeelding invoegen',
    italic: 'Cursief',
    orderedList: 'Nummering (1, 2, 3, ...)',
    unorderedList: 'Opsomming',
    removeFormat: 'Opmaak verwijderen.\nMaakt titels, vetgedrukt, cursief, onderstreept etc. ongedaan.',
    separator: null,
    table: 'Tabel invoegen',
    underline: 'Onderstrepen'
}